import { HashStore } from '@pulse/browser-shared';
import { PulseAttributeMessage, TrackerConfigurations, TransformPipe } from '@pulse/common';

/**
 * Filter out attributes that are not changed since the last firing.
 */
export class ChangedAttributesPipe implements TransformPipe<PulseAttributeMessage> {
    constructor(
        private hashStore: HashStore,
        private config: TrackerConfigurations,
    ) {}

    transform(message: PulseAttributeMessage): PulseAttributeMessage[] {
        const attribute = message.data;

        if (typeof attribute !== 'object' || !attribute || Array.isArray(attribute)) {
            return [];
        }

        const key = `attribute_${attribute.name}`;
        const value = `${attribute.type}_${attribute.value}`;
        const changed = this.hashStore.changed(key, value, this.config.attributeTimeoutMS);

        return changed ? [message] : [];
    }
}
